import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logActivity, classifyClick, pageNameFor } from './activityLogger';

// Invisible component mounted once inside the Router.
// - Logs a PAGE_VIEW every time the route changes.
// - Logs every click on a button / link / clickable control, classifying
//   edit / delete / create actions from the control's label.
const ActivityTracker = () => {
  const location = useLocation();

  // Page views
  useEffect(() => {
    logActivity('PAGE_VIEW', { page: pageNameFor(location.pathname) });
  }, [location.pathname]);

  // Global click capture
  useEffect(() => {
    const handleClick = (e) => {
      const el = e.target.closest(
        'button, a, [role="button"], [type="submit"], .sidenav-item, .MuiListItem-root, .MuiIconButton-root, .MuiMenuItem-root'
      );
      if (!el) return;

      const label = (
        el.getAttribute('aria-label') ||
        el.getAttribute('title') ||
        el.innerText ||
        el.getAttribute('alt') ||
        ''
      )
        .trim()
        .replace(/\s+/g, ' ')
        .slice(0, 80);

      if (!label) return; // ignore unlabeled icon-only noise

      logActivity(classifyClick(label), {
        page: pageNameFor(window.location.pathname),
        target: label,
      });
    };

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, []);

  return null;
};

export default ActivityTracker;
